import BaseRestClient from "./baseClient";

export function fetchActivities()  {
  return BaseRestClient.fetch('/api/v1/activities');
}

export function markActivitiesRead() {
  return BaseRestClient.put('/api/v1/activities/read', null);
}
